
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import FormMixin from "../../helpers/mixins/form";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { SystemApi, EmailTemplateTypeEnum, GetEmailTemplate } from "../../autogen";

type FormValues = {
  name: string;
  message: string;
};

@Options({
  components: { Field, Form, FieldLabel, FieldError, FormError, ActionButton }
})
export default class EmailTemplateForm extends FormMixin {
  @Prop({ type: Object }) mailTemplate: GetEmailTemplate | null = null;
  globalErrors: { message: string }[] = [];
  formName = "メールテンプレート";
  formValues: FormValues = {
    name: "",
    message: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "テンプレート名" })),
      message: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "テンプレート本文" }))
    });
  }
  beforeMount() {
    if (this.mailTemplate) {
      this.formValues = {
        name: this.mailTemplate.name,
        message: this.mailTemplate.message
      };
    } else {
      this.formValues = {
        name: "",
        message: ""
      };
    }
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.mailTemplate) {
        await new SystemApi().updateEmailTemplate({
          emailTemplateId: this.mailTemplate.emailTemplateId,
          emailTemplateType: EmailTemplateTypeEnum.As,
          emailTemplateUpdate: values
        });
      } else {
        await new SystemApi().createEmailTemplate({
          emailTemplateCreate: Object.assign({ emailTemplateType: EmailTemplateTypeEnum.As }, values)
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    if (!this.mailTemplate) return;
    await this.onDelete(async () => {
      await new SystemApi().deleteEmailTemplate({
        emailTemplateId: this.mailTemplate!.emailTemplateId,
        emailTemplateType: EmailTemplateTypeEnum.As
      });
    });
  }
}
